export var DevicePreloadTimeInSeconds = /*#__PURE__*/ function(DevicePreloadTimeInSeconds) {
    DevicePreloadTimeInSeconds[DevicePreloadTimeInSeconds["DEFAULT"] = 5] = "DEFAULT";
    DevicePreloadTimeInSeconds[DevicePreloadTimeInSeconds["HU32E5600FHWV"] = 4] = "HU32E5600FHWV";
    DevicePreloadTimeInSeconds[DevicePreloadTimeInSeconds["HU43A6109FUWV"] = 5] = "HU43A6109FUWV";
    return DevicePreloadTimeInSeconds;
}({});

//# sourceMappingURL=vidaa-types.js.map